export default __webpack_public_path__ + "static/media/menu.70d5ab42.svg";